import { useSelector } from "react-redux";
import { redirigirSegunUser } from "utils/generalFunctions";

const FacturacionProtectedRoutes = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (user?.roles[0] == "Facturacion") {
    return children;
  } else {
    return redirigirSegunUser(user);
  }
};

export default FacturacionProtectedRoutes;
